import React, { useCallback, useEffect } from 'react';
import ReactDOM from 'react-dom';
import AdverNew from '@Components/ad/AdverNew';
import { fetchUser } from '@Services/api';
import styles from './touchDetail.module.less';
import Audio from './audio';
import judgeAppVersionCode from '@Lib/judgeAppVersionCode';

const replaceContent = function (item) {
  const { discount_price, kind_alias_name, kind_id } = item;

  let sumUrl = `tcnewcar://newcar/info?k=${kind_id}`;
  let balanceUrl = `tcnewcar://newcar/balance?k=${kind_id}`;
  let discountUrl = `tcnewcar://newcar/info?k=${kind_id}&title="優惠"`;
  let discountDom =
    discount_price === ''
      ? ''
      : `|<a href="${discountUrl}"  target="_blank" onclick="logEvent('文章內頁', '優惠');">優惠</a>`;
  let dom =
    `<span style="color:#3264FF;" ><a  target="_blank" href="${sumUrl}">${kind_alias_name}</a>(<a  target="_blank" onclick="logEvent('文章內頁', '配備');"  href="${balanceUrl}">配備</a>` +
    discountDom +
    ')</span>';

  let contentDom = document.getElementById(window.article_id);
  let pDom = contentDom.getElementsByTagName('p');
  // 不替換 超級測試賽道成績模塊 内部廠牌
  let testContent = document.querySelector('.super-test-content');
  let testHTMLContent = testContent?.innerHTML || '';

  for (let i = 0; i < pDom.length; i++) {
    let text = pDom[i].innerText;

    if (text?.includes(kind_alias_name)) {
      if (text?.includes('超級測試賽道成績')) {
        if (testContent) {
          testContent.innerHTML = '';
        }

        let domReplace = pDom[i].innerHTML.replace(kind_alias_name, dom);
        pDom[i].innerHTML = domReplace;
        document.querySelector('.super-test-content').innerHTML = testHTMLContent;

        break;
      } else {
        let domReplace = pDom[i].innerHTML.replace(kind_alias_name, dom);
        pDom[i].innerHTML = domReplace;

        break;
      }
    }
  }
};

async function user() {
  const res = await fetchUser();
  if (res?.status === 12000) {
    localStorage.setItem('buycar_stage', res.data.phase);
  }
}

const TouchArticleDetailTopBannerAd: React.FC = () => {
  let slot = '/173427088/newcar-app-news-topad';
  let _event = {};

  const slotRenderEnded = (event) => {
    if (event.slot.getAdUnitPath() === slot && !event.isEmpty && Object.keys(_event).length === 0) {
      let _html = event.slot.getHtml();

      try {
        _event = JSON.parse(_html.match(/---(.*)---/)[1]);
        handleResize();

        window.addEventListener('resize', handleResize);
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      } catch (e) {
        console.log(`${event.slot.getAdUnitPath()}:沒有廣告格式`);
        return false;
      }
    }
  };

  const handleResize = useCallback(() => {
    const ad = document.getElementById(slot);
    if (ad) {
      const content = document.getElementById('content');
      const width = content?.offsetWidth;
      if (width && width > 0 && width < 750) {
        const scale = width / 750;
        const root = document.getElementById('newcar-touch-news-topad');
        if (root) {
          const parent = root.querySelector('div');
          if (parent) {
            // parent.style.height = 145 * scale + 'px';
            parent.style.position = 'relative';
            parent.style.top = '0.1px';
            // parent.id = 'div-gpt-ad-1508319522490-200'
          }
        }
        // ad.style.transform = `scale(${scale})`;
        ad.style.transformOrigin = 'left top';
        ad.style.position = 'absolute';
      }
    }
  }, []);

  useEffect(() => {
    if (window.kindInfos.length !== 0) {
      window.kindInfos.map((v) => replaceContent(v));
    }

    window.googletag &&
      window.googletag.cmd.push(() => {
        window.googletag.pubads().addEventListener('slotRenderEnded', slotRenderEnded.bind(this));
      });

    user();
  }, []);

  return <AdverNew slot={slot} width={750} height={72} atarget="_self" className={styles['touch-article-topad']} />;
};

const $app = document.getElementById('audio');

!!$app &&
  window.audioSrc &&
  judgeAppVersionCode({
    android_limit_version: '4.30.0',
    ios_limit_version: '4.30.0',
  }).then((res) => {
    if (res) {
      ReactDOM.render(
        <Audio
          voiceData={{
            url: window.audioSrc,
            questionnairePosition: window.questionnairePosition,
          }}
        />,
        $app,
      );
    }
  });

const AdContainer = document.getElementById('newcar-touch-news-topad');
AdContainer && ReactDOM.render(<TouchArticleDetailTopBannerAd />, AdContainer);
